import React from "react";
import { Redirect } from "react-router-dom";
import AccountComponent from "../components/accountpage/AccountComponent";
import QueryLoading from "../components/animations/QueryLoading";

const AccountPage = ({ userLoading, userData, refetchUser }) => {
  if (userLoading) {
    return <QueryLoading />;
  }
  if (userData) {
    return <AccountComponent userData={userData} refetchUser={refetchUser} />;
  }
  return <Redirect to="/login" />;
};

export default AccountPage;
